"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const useBulkWizardActionsContext_1 = __importDefault(require("../hooks/useBulkWizardActionsContext"));
const BulkDrippingCounter = () => {
    const { t } = (0, translationContext_1.useTranslation)();
    const { total } = (0, useBulkWizardActionsContext_1.default)();
    return ((0, jsx_runtime_1.jsxs)("span", { className: "_text-gray-500", children: [t('dripping_2.new.bulk_action.title'), (0, jsx_runtime_1.jsx)("span", { className: "_mx-3", children: '·' }), (0, jsx_runtime_1.jsx)("span", { children: t('dripping_2.new.bulk_action.amount', {
                    data: { value: total },
                    amountToPluralize: total
                }) })] }));
};
exports.default = BulkDrippingCounter;
